module.exports = __webpack_public_path__ + "img/cloud.9607a901.svg";